import React from "react"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TimecardPunchControl from "./TimecardPunchControl"
import { IPunchSetDocument, ITimecardDay } from "../../models"
import EquipmentTimecardTablePSCell from "./EquipmentTimecardTablePSCell"
interface IProps {
    fullPunchSets: IPunchSetDocument[]
    day: ITimecardDay
    hierarchyItemId: string
    positionId: string
    timecardLocked: boolean
    readonly: boolean
    addPunch(day: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, employeeId: string, shiftId: string, jobId: string, phaseId: string, isPunchIn: boolean, pairedPunchId: string): void
    onConfirmDelete(punchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    reloadTimecard(msg: string): void
}

const EquipmentTimecardTableDay: React.SFC<IProps> = (props: IProps) => {
    const dayPunchSets = props.day.PunchSets.map(timecardPS => props.fullPunchSets.find(i => i.Id === timecardPS.Id))
    return (
        <TableRowColumn className="EquipmentTimecardTableRowColumn" style={{ textAlign: "left", verticalAlign: "top" }}>
            <div style={{ paddingBottom: 10 }} onClick={(e) => e.stopPropagation()}>
                {dayPunchSets.map((punchSet, i) =>
                    <EquipmentTimecardTablePSCell
                        key={i}
                        day={props.day}
                        timecardLocked={props.timecardLocked}
                        readonly={props.readonly}
                        punchSet={punchSet}
                        addPunch={props.addPunch}
                        onConfirmDelete={props.onConfirmDelete}
                        onTimeChange={props.onTimeChange}
                        reloadTimecard={props.reloadTimecard}
                    />
                )}
                {!(props.timecardLocked || props.readonly) &&
                    <TimecardPunchControl
                        hintText="+ ADD"
                        value={null}
                        onAddPunch={() => props.addPunch(props.day, props.hierarchyItemId, props.positionId, null, null, null, null, null, null, true, null)}
                    />}
            </div>
        </TableRowColumn>
    )
}

export default EquipmentTimecardTableDay
